import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { writeSelectedStaffId } from "../common/staff/staffIdentityStorage";

/**
 * Log out, clearing anything that belongs to the person rather than the device.
 *
 * Exists because the staff identity picker outlives an Auth0 session: it is stored per
 * device so a reception PC doesn't have to re-pick on every page. Without clearing it here,
 * the next person to log in on that machine — on an account that is also unlinked — would
 * silently inherit the previous person's identity, and their tasks, messages and call notes
 * would all be attributed to someone who had gone home.
 *
 * Use this in preference to calling `useAuth0().logout` directly, so a new logout entry
 * point can't reintroduce that.
 */
export function useLogout(): () => void {
  const { logout } = useAuth0();

  return useCallback(() => {
    writeSelectedStaffId(null);
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);
}
